module.exports = __webpack_public_path__ + "img/farming-mining-and-construction-icon.f27297be.svg";